import { LtlPipelineViewModel } from "./LtlPipelineViewModel";

export const getSpdrOrPdsrIdFromLtlPipeline = (ltlPipeline: LtlPipelineViewModel) => {
  return ltlPipeline?.SpdrId ?? ltlPipeline?.PdsrId;
};
